// extracted by mini-css-extract-plugin
module.exports = {"root":"_1fayu","line":"_2KBJF"};